import { createContext, useContext, useState, useCallback, useEffect } from 'react';

const CampaignsContext = createContext();

export const useCampaigns = () => {
  const context = useContext(CampaignsContext);
  if (!context) {
    throw new Error('useCampaigns must be used within CampaignsProvider');
  }
  return context;
};

export const CampaignsProvider = ({ children }) => {
  // Cache de dados
  const [cachedData, setCachedData] = useState({
    selectedSavedAccount: null,
    selectedMcc: null,
    selectedAdsAccount: null,
    campaigns: [],
    accountNames: {},
    lastUpdate: null,
  });

  // Verificar se tem dados em cache
  const hasCache = cachedData.campaigns.length > 0;

  // Salvar dados no cache
  const saveToCache = useCallback((data) => {
    setCachedData({
      ...data,
      lastUpdate: new Date(),
    });
  }, []);

  // Limpar cache
  const clearCache = useCallback(() => {
    setCachedData({
      selectedSavedAccount: null,
      selectedMcc: null,
      selectedAdsAccount: null,
      campaigns: [],
      accountNames: {},
      lastUpdate: null,
    });
  }, []);

  // Restaurar dados do cache
  const restoreFromCache = useCallback(() => {
    return cachedData;
  }, [cachedData]);

  const value = {
    // Estado do cache
    hasCache,
    cachedData,
    lastUpdate: cachedData.lastUpdate,
    
    // Funções
    saveToCache,
    clearCache,
    restoreFromCache,
  };

  return (
    <CampaignsContext.Provider value={value}>
      {children}
    </CampaignsContext.Provider>
  );
};